"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupable = void 0;
var tslib_1 = require("tslib");
function getRows(groups, columns) {
    var groupMap = {};
    var parentMap = {};
    var headIndexMap = {};
    groups.forEach(function (_a) {
        var key = _a.key, title = _a.title, align = _a.align, children = _a.children;
        groupMap[key] = { key: key, title: title, align: align, children: children };
        children.forEach(function (child) {
            parentMap[child] = key;
        });
    });
    columns.forEach(function (_a, index) {
        var key = _a.key;
        headIndexMap[key] = index;
    });
    // 获取各分组 [层级，包含列数，排序]
    var traverse = function (node) {
        if (groupMap[node] && groupMap[node].children) {
            var level_1 = -1;
            var colSpan_1 = 0;
            var minIndex_1 = columns.length;
            groupMap[node].children.forEach(function (child) {
                var _a = tslib_1.__read(traverse(child), 3), childLevel = _a[0], childColSpan = _a[1], childIndex = _a[2];
                level_1 = Math.max(childLevel, level_1);
                colSpan_1 += childColSpan;
                minIndex_1 = Math.min(minIndex_1, childIndex);
            });
            return [level_1 + 1, colSpan_1, minIndex_1];
        }
        // 原始列
        return [0, 1, headIndexMap[node]];
    };
    var rows = [];
    // 分组头
    groups.forEach(function (_a) {
        var key = _a.key;
        var _b = tslib_1.__read(traverse(key), 3), level = _b[0], colSpan = _b[1], order = _b[2];
        groupMap[key] = tslib_1.__assign(tslib_1.__assign({}, groupMap[key]), { order: order,
            level: level,
            colSpan: colSpan });
        if (!rows[level]) {
            rows[level] = [groupMap[key]];
        }
        else {
            rows[level].push(groupMap[key]);
        }
    });
    var headRowSpanMap = {};
    // 原始头
    columns.forEach(function (_a) {
        var key = _a.key;
        var level = parentMap[key]
            ? groupMap[parentMap[key]].level - 1
            : (rows.length || 1) - 1;
        var head = {
            key: key,
            isLeaf: true,
            order: headIndexMap[key],
            rowSpan: level + 1,
        };
        if (!rows[level]) {
            rows[level] = [head];
        }
        else {
            rows[level].push(head);
        }
        headRowSpanMap[key] = head.rowSpan;
    });
    // 排序
    return [
        rows.map(function (row) { return row.sort(function (a, b) { return a.order - b.order; }); }).reverse(),
        headRowSpanMap,
    ];
}
function groupable(_a) {
    var headerGroups = _a.headerGroups;
    var rows;
    var headRowSpanMap;
    return {
        getInfo: function () { return ({ name: "groupable" }); },
        onInjectProps: function (props) {
            var _a;
            _a = tslib_1.__read(getRows(headerGroups, props.columns), 2), rows = _a[0], headRowSpanMap = _a[1];
            return tslib_1.__assign(tslib_1.__assign({}, props), { headerRows: rows });
        },
        onInjectColumn: function (previous) { return function (record, rowKey, recordIndex, column, columnIndex) {
            var _a = previous(record, rowKey, recordIndex, column, columnIndex), props = _a.props, result = tslib_1.__rest(_a, ["props"]);
            if (recordIndex === -1) {
                return tslib_1.__assign(tslib_1.__assign({}, result), { props: tslib_1.__assign(tslib_1.__assign({}, props), { rowSpan: headRowSpanMap ? headRowSpanMap[column.key] : undefined }) });
            }
            return tslib_1.__assign(tslib_1.__assign({}, result), { props: props });
        }; },
    };
}
exports.groupable = groupable;
//# sourceMappingURL=groupable.js.map